module.exports = {
    m: {
        lang: 'zh',
        header: {
            product: '产品',
            support: '支持',
            roadmap: '路线图',
            forum: '论坛',
            buynow: '立即购买',
        },
        footer: {
            title: 'SKYBOX 保留所有权利。',
            term: '使用条款',
            pri: "隐私政策",
            content: "联系我们"
        },
        product: {
            title: "最好用的 VR 视频播放器",
            skyboxOne: 'SKYBOX&nbsp;',
            skyboxTwo: 'VR PLAYER',
            getapp: '立即购买',
            magic: '流畅无损地',
            magicZero: '无线播放',
            magicOne: 'AirScreen 无线推流功能，可以将你电脑中的视频通过 Wi-Fi 实时推送到你的 VR 头显上，',
            magicTwo: "实现流畅无损的播放体验。你甚至可以将视频同时推送至多台设备，与好友、家人一起观看。",
            magicThree: '在 VR 头显上观看、浏览、管理你电脑中的视频从未如此方便。',
            magicFour: "",
            support: "支持所有主流",
            supportZero: '&nbsp;VR 平台',
            supportOne: 'SKYBOX 支持所有主流 VR 平台，包括 Oculus, Steam VR, Gear VR, Daydream 以及更多。',
            supportThree: "无论你处于哪种平台，都可以享受到同样极致的体验。",
            envir: "无比沉浸的 3D 场景",
            envirOne: "内置多个影院场景供你选择，你可以享受到在电影院、太空站、月球或虚空中观看 2D 或 3D 电影的沉浸式体验。",
            elegant: "强大功能之上的",
            elegantOne: "优雅体验",
            eleOne: "SKYBOX 有着优雅的界面和顺畅的用户体验。 让你仅需几次轻点，就可以体",
            eleTwo: "验到它丰富的功能和强大的性能。",
            all: "支持所有主流",
            allOne: "立体模式",
            allTwo: "支持所有主流立体模式，无论是 2D、3D， 还是 180°、360°，甚至是特殊的 Youtube EAC 模式，都可以实现无缝播放。",
            engine: "图像识别引擎",
            engineOne: "内置基于图像识别的立体模式识别引擎，所有视频在播放之前便可以匹配到相应的立体模式，精准度超过 90%，无需你再进行繁琐的手动设置。",
            format: "视频格式",
            formatOne: "SKYBOX 可以播放所有主流视频格式，并且提供了多种你可能需要的视频调节功能。",
            side: "2D，3D 上下，3D 左右，180°，360°",
            sub: "字幕和音轨选择",
            eightk: "支持 8K&nbsp;",
            sup: "超高清视频",
            supOne: "SKYBOX 拥有强大的解码性能，UHD、4K、8K 视频的流畅播放都不在话下。 在 Quest 2 上，可播放尺寸为 8192x6144 的视频。你甚至可以使用 AirScreen 功能将 8K 视频实时推流到 VR 设备中。",
            enjoy: "支持本地媒体服务器",
            enjoyOne: "全方位支持 DLNA、Samba 协议， 你可以直接通过 Wi-Fi 浏览和播放本地路由器",
            enjoyTwo: " 或者 NAS 中的视频，为你的移动设备节省大量空间。",
            feat: "产品特性",
            featOne: "支持所有主流视频格式和分辨率",
            featTwo: "支持所有主流 VR 视频立体模式",
            featThree: "支持所有主流 VR 平台",
            featFour: "支持按储存路径查找视频文件",
            featFive: "支持切换音轨和内嵌、外挂字幕",
            featSix: "内置多个逼真的影院场景",
            featSeven: "AirScreen：PC 无线推流至 VR 设备",
            featEight: "图像识别引擎：自动识别视频立体模式",
            featNine: "隐藏文件：隐藏后只在 SKYBOX 内显示",
            featTen: "私密文件：应用内将文件夹加密并隐藏",
            featEleven: "易用的交互方式和简洁的 UI 界面",
        },
        zendesk: {
            title: "联系我们",
            name: "你的名字",
            email: "你的邮箱",
            qsO: "选择你使用的 VR 头显",
            qsT: "选择问题种类",
            dec: "如在使用中遇到任何问题，请描述问题本身和如何遇到问题的。\n如想要 SKYBOX 支持新的功能，请描述你的需求和使用场景。",
            sub: "提交",
            fail: "此邮箱地址无效。",
            null: "此项为必填项。",

            restitle: "谢谢你的来信。",
            container: "我们的支持人员将在周一至周五发送回复到你填的邮箱中。<br>感谢你的耐心等待。",
        },
        sedNav: {
            supportTitle: "支持",
            search: "搜索",
            content: "内容",
        },
        sidebar: {
            fre: "常见问题",
            havequsetion: "仍有疑问？",
            submitticket: '联系我们',
        },
        supportTitle: {
            playback: '3D/180/360 视频播放',
            frequently: '常见问题',
            features: '功能',
            general: '其他问题'
        },
        get: {
            title: '获取应用',
            vr: 'VR 设备',
            pc: 'PC / Mac 客户端',
            apk: 'APK 下载',
            pre: '已预装',
            note: '版本记录',
            all: '所有平台',
            release: '发布日期：',
            // innerBox: {
            //     title: '选择适合你的 Mac 的 SKYBOX 客户端',
            //     containerOne: "SKYBOX Mac 客户端支持 macOS 10.13.x High Sierra 及更高版本。随着 macOS 新版本的更新，我们也会发布新版本确保 SKYBOX 客户端的正常使用。",
            //     containerTwo: "如何查看 Mac 使用的是哪个 macOS 版本？",
            //     containerThree: "从屏幕角落的苹果菜单",
            //     containerFour: " 中选取“关于本机”。",
            //     btnOne: "macOS 11 & 更高版本",
            //     btnTwo: "其他 macOS 版本",
            // },
            innerBox: {
                title: '选择适合你 Mac 的 SKYBOX 客户端',
                containerOne: "SKYBOX Mac 客户端要求 macOS 系统为 10.11（El Capitan）或更高版本。",
                containerTwo: "如何查看 macOS 系统版本及芯片：",
                containerThree: "点击电脑左上角的",
                containerFour: "图标，选择“关于本机”。",
                btnOne: "M1及M2 芯片",
                btnTwo: "Intel 芯片",
            }
        },
        content: {
            look: {
                title: "为什么有些视频在播放时看起来不太对？",
                one: "主流 VR 视频格式分为 360 度、180 度、3D 上下分屏以及 3D 左右分屏。SKYBOX 全部支持。",
                two: "SKYBOX 内置的识别引擎可以自动识别并切换到正确格式，但仍无法避免有少数视频会识别失败。",
                three: "当识别出现错误时，请进行以下操作：",
                four: "（1）点击播放控制面板右侧的“立体模式”按钮。",
                five: "（2）点击“自动识别”，查看视频是否正常。",
                six: "（3）如果此时视频看起来仍然不太对，点击菜单中的“重置”。",
                seven: "（4）根据你所看到的画面手动设置成正确的立体模式。",
                eight: "如果在播放 3D 视频时，出现眼睛不舒适如无法对焦的情况，很大情况是因为该视频在拍摄时设置了错误的眼距。针对这类视频，你可以在“高级设置”面板中，打开“单眼模式”，即可使双眼播放同样的画面，抵消不适感。"
            },
            howair: {
                title: "如何使用 AirScreen 观看电脑端的视频？",
                one: "SKYBOX 播放器的 AirScreen 功能可以实现将 PC 端的视频，实时无损地推流至一台或多台移动 VR 设备上播放，而无须将此视频传输至移动设备内，以此节省设备的存储空间和你的时间。以下是推流功能的使用步骤：<br /><br />(1) 安装 SKYBOX 播放器 PC 端，你可以点击 <a href='/get' style='color: #ffc820;'>&nbsp; 这里 </a> 下载。",
                two: "(2) 保证你的 VR 设备和电脑处于同一 Wi-Fi 网络下。",
                three: "(3) 打开 SKYBOX PC 端，拖拽视频或文件夹至播放器界面中，或点击左上角的 “Open” 按钮添加视频。",
                four: "(4) 在 SKYBOX VR 端切换至 “AirScreen” 页面。",
                five: "(5) 点击 “查找设备” 按钮，连接至已查找到的设备。",
                six: "(6) 点击视频封面即可观看。<br /><br />如果按以上步骤无法找到设备或者无法连接，请查看：<a href='/why-cant-i-search-for-devices-or-connect-to-my-pc-client' style='color: #ffc820;'>&nbsp;为什么使用 AirScreen 无法找到设备或者设备无法连接？ </a>",
            },
            searchfor: {
                title: "为什么使用 AirScreen 无法找到设备或者设备无法连接？",
                one: "(1) 检查 PC 和移动设备是否处于同一个局域网（Wi-Fi）环境内。",
                two: "(2) 分别检查 PC 和移动设备是否使用了代理服务器，如 Express VPN, Astrill, ShadowSocks 等，如有，请关闭 VPN。",
                three: "(3) 检查 Windows 防火墙是否将 SKYBOX PC 客户端拦截，如果被拦截，请按以下步骤操作：",
                four: "<1> 打开 “控制面板 ”，进入 “Windows 防火墙 ” 页面。",
                five: "<2> 在左侧点击 “允许应用或功能通过 Windows 防火墙”。",
                six: "<3> 将所有 “SKYBOX.exe” 打勾，点击 “确定” 按钮。",
                seven: "如果仍然找不到设备，请重启两端软件和设备重试。",
            },
            videos: {
                title: "如何观看本地媒体服务器上的视频文件？",
                one: "SKYBOX 播放器全方位支持 DLNA、Samba 协议，你可以直接通过 Wi-Fi 浏览和播放本地路由器或者 NAS 中的视频。",
                two: "启动 SKYBOX 播放器后，点击左侧面板中的 “本地网络” Tab，你就会看到本地网络中所有可访问的媒体服务器。",
                three: "如果出现无法找到、访问媒体服务器，或媒体服务器内文件为空的情况，请检查 VR 设备与媒体服务器是否处于同一个局域网环境下，然后在媒体服务器或路由器后台检查是否开启了 VR 设备的访问权限。<br /><br />如果你没有外置的本地媒体服务器设备，你可以使用 Windows 的媒体流功能来共享视频，方法请查看：<a href='/how-to-turn-on-media-streaming-in-windows/' style='color: #ffc820;'>如何在 Windows 中启用媒体流共享？</a>",
            },
            media: {
                title: "如何在 Windows 中启用媒体流共享？",
                one: "（1）打开 Windows 控制面板。",
                two: "（2）在搜索框中输入 “媒体”，然后选择结果中的 “媒体流选项”。",
                three: "（3）点击 “启用媒体流”。",
                four: "（4）你可以为你的媒体库命名。",
                five: "（5）右键点击你想共享的视频文件或文件夹，选择 “包含到库中” > “视频”。",
                six: "如果你想关闭媒体流共享，请点击 “全部阻止”，然后点击 “确定” 即可。",
            },
            updating: {
                title: "After updating SKYBOX to the newest version (v0.2.0 and after), I cannot access/play videos in the SMB folder?",
                one: "This may happen because there is a limit on the number of simultaneous users to access SMB share folder.",
                two: "Follow the steps below to change the setting in Windows 10:",
                three: "(1) Right click on the folder which you want to share and select “Properties”.",
                four: "(2) Choose the “Sharing” Tab and click on the “Advanced Sharing”.",
                five: "(3) Here set the “Limit the number of simultaneous users to” to 20 and click “Apply”.",
                six: "Reboot SKYBOX on your device and check if you can successfully playback videos on SMB share.",
                seven: "If videos still fail to playback , please drop us an email at <a href='mailto:contact@skybox.xyz' style='color: #ffc820;'>contact@skybox.xyz</a>",
            },
            hide: {
                title: "如何在相册中隐藏我的视频？",
                one: "如果你想将特定视频在相册类应用中隐藏，你可以将它们存放到手机根目录 SKYBOX 文件夹下的 “Hide” 文件夹中。这样这些视频就只会在 SKYBOX 中显示。",
            },
            load: {
                title: "如何加载字幕和切换音轨？",
                one: "SKYBOX 播放器支持在播放非 VR 视频时显示字幕。要加载外置字幕，请将字幕文件和视频文件存放在同一文件夹下，并保持文件名一致（不包含扩展名）。",
                two: "然后在播放界面，点击控制面板左侧的 “字幕和音轨” 按钮，选择相对应的字幕即可。",
                three: "如果视频包含多条音轨，你可以点击上方 “音轨” Tab，切换你想要的音轨。",
            },
            phone: {
                title: "如何观看 VR 设备内的视频？",
                one: "你可以直接将想要播放的视频拷贝到 VR 设备的内部存储或 SD 卡内，即可在应用中的 “所有视频” 页面中查看到相应视频。",
                two: "SKYBOX 可以自动识别 VR 模式的视频，你可以切换到 “VR 视频” 页面查看设备内所有的 VR 视频。",
            },
            show: {
                title: "为什么我的视频没有显示？",
                one: "SKYBOX 会自动扫描本地的所有视频，并将可以播放的视频显示在 “所有视频” 页面中。",
                two: "如果你的视频未被显示，也许是它被认作了无法播放的视频，请切换到 “目录” 页面，按路径查找该视频并尝试播放。若该视频可以播放，则会被自动加入到 “所有视频” 页面。",
                three: "SKYBOX 目前支持 mp4, mkv, avi, mov, wmv, rmvb, flv, 3gp, webm, vob 等主流格式的视频，如果你在路径查找中也未找到你的视频，也许是因为它是我们还不支持的特殊格式。我们会持续提升支持视频的种类。",
            },
            // howair: {
            //     title: "",
            //     one: "",
            //     two: "",
            //     three: "",
            //     four: "",
            //     five: "",
            //     six: "",
            //     seven: "",
            //     eight: "",
            //     nine: "",
            //     ten: "",
            // },
            adjust: {
                title: "如何调整屏幕的大小和位置？",
                one: "在播放普通影片时，如果想要调整屏幕大小和位置。你需要切换到虚空场景：呼出“控制面板”点击右上角的“选择影院”按钮，选择“虚空” 。",
                two: "然后，将光标指向屏幕，按住触控板或扳机来拖动屏幕。你还可以通过上下滑动触控板来调整屏幕大小。",
                three: "或者你可以通过呼出控制面板右侧的“高级设置”面板，手动调整屏幕的“倾角”和“缩放”选项。",
            },
            airscreen: {
                title: "什么是 AirScreen？",
                one: "AirScreen 能够让你用移动 VR 设备，如 Gear VR、Oculus Go 或 Daydream 观看电脑中的视频，",
                two: "无须将视频传输至 VR 设备内，以节省设备存储空间和你的时间。你可以点击<a href='/get' style='color: #ffc820;'>&nbsp; 这里 </a>下载。",
            },
        }
    },
}